module.exports = __webpack_public_path__ + "static/media/icon-whole-home.637f3c71.svg";